"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeStaticComparisonSpec = void 0;
/**
 * @param message The user facing string to describe this spec. Unused outside
 * the adjust and compare screen in phoenix.
 * @param value The value to compare against
 * @returns
 */
var makeStaticComparisonSpec = function (message, value) {
    return {
        type: 'STATIC_COMPARISON',
        value: value,
        message: message,
    };
};
exports.makeStaticComparisonSpec = makeStaticComparisonSpec;
//# sourceMappingURL=StaticComparisonSpec.js.map